module.exports = __webpack_public_path__ + "img/e50c640.jpg";